/**
 * Enum para os itens de completude do perfil do usuário
 * Utilizado para verificar quais informações o usuário já preencheu
 */
export enum ProfileCompletionItem {
  // Nível 1 - Dados pessoais
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  NATIONAL_ID = 'NATIONAL_ID',

  // Nível 2 - Dados de contato
  MOBILE_PHONE = 'MOBILE_PHONE',
  ADDRESS = 'ADDRESS',

  // Nível 3 - Veículo
  VIN = 'VIN',

  // Nível 4 - Carro conectado e concessionária
  CONNECT_CAR = 'CONNECT_CAR',
  PREFERRED_DEALER = 'PREFERRED_DEALER',
}
